<template>
  <div class="rated-page py-5 my-3">
        <ul class="list-unstyled rate">
          <li><i class="bi bi-star-fill mx-2"></i></li>
          <li><i class="bi bi-star-fill mx-2"></i></li>
          <li><i class="bi bi-star-fill mx-2"></i></li>
          <li><i class="bi bi-star-fill mx-2"></i></li>
          <li><i class="bi bi-star-half mx-2"></i></li>
        </ul>
        <p class="text-capitlize fw-bold mt-2">
          CarCare IS RATED 4.7/5.0 IN CUSTOMER SATISFACTION.<br />
          RATING BASED ON 532 REVIEWS.
        </p>
        <p class="big-p">
          Our top priority with the acquisition of NuWash’s Dallas operations is
          to make it seamless for you to transition. You can download the
          carecare app and log in with your existing NuWash credentials to see
          your wash history and book carcare services. carcare will continue to
          deliver the traditional mobile car wash and detail services that you
          are familiar. We use minimal water, eco-friendly cleaning supplies,
          and a proprietary reclamation system.
        </p>
      </div>
</template>

<script>
export default {

}
</script>

<style>
.rate li {
  display: inline-block;
  font-size: 60px;
  color: rgb(233, 218, 14);
}
.rated-page p:first-of-type {
  letter-spacing: 2px;
}
.big-p {
  line-height: 2;
  font-size: 20px;
}
</style>